import FALLBACK_LABELS from '../constants/fallback_labels';
import { createUseLabelsHookFromStore } from '@tme/toyota-common';

export const useLabels = createUseLabelsHookFromStore(
	FALLBACK_LABELS,
	`content`
);
